export default __webpack_public_path__ + "static/color-spots-light-39ba4729c3f9f493e5ed6cfff701969f.png";